import jwt_decode from "jwt-decode";

export function getJwt() {
  return window.localStorage.getItem('jwt');
}

export function getSession() {
  try {
    const jwt = window.localStorage.getItem('jwt');
    if (jwt) return jwt_decode(jwt);
  }catch (e) {
    console.error(e);
  }
}

export function setSession(jwt) {
  try {
    window.localStorage.setItem('jwt', jwt);
  }catch (e) {
    console.error(e);
  }
  /*
          const {user} = jwt_decode(r.jwt);
        if (user) {
          window.localStorage.setItem('userKey', user.userId);
          window.localStorage.setItem('user', user)
          window.location.replace('/');
        }

   */
}

export function removeSession() {
  window.localStorage.removeItem('jwt');
}
